module.exports = __webpack_public_path__ + "img/btn-fix-equity-empty.bfca547a.png";